import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    session: null,
    showTracks: true,
    showAlerts: true,
    showIdles: false,
    showStops: true,
    showHeadings: true,
    loading: false

  },
  mutations: {
    setSession: (state, payload) =>{
      state.session = payload;
    },
  },
  actions: {
    setSession: (context, payload) =>{
      context.commit('setSession', payload)
    },
  },
  modules: {
  }
})
